import { takeLatest, put } from "redux-saga/effects";

import configRepository, { OfficeServerDetails } from "../../../domain/repositories/ConfigRepository";

import {
  TRIGGER_GET_ALL_OFFICE_SERVERS,
  TriggerGetAllOfficeServers,

  RESET_GET_ALL_OFFICE_SERVERS
} from "./types";

import {
  getAllOfficeServersPending,
  getAllOfficeServersSuccess,
  getAllOfficeServersError
} from "./actions";
import { createCancellableSaga } from "../../../../../store/CancellableSaga";


function* handleTriggerGetAllOfficeServers(action: TriggerGetAllOfficeServers) {
  yield put(getAllOfficeServersPending());

  let response: OfficeServerDetails[];

  try {
    response = yield configRepository.getAllOfficeServers();
  } catch (err) {
    yield put(getAllOfficeServersError());
    return;
  }

  yield put(getAllOfficeServersSuccess(response));
}


export function* watchGetAllOfficeServersSaga() {
  yield takeLatest(TRIGGER_GET_ALL_OFFICE_SERVERS, handleTriggerGetAllOfficeServers);
}


export const getAllOfficeServersSaga = createCancellableSaga(
  watchGetAllOfficeServersSaga, RESET_GET_ALL_OFFICE_SERVERS
);